import { FullLoadingOverlayProvider } from '@/pages/_providers/full-loading-overlay-provider';
import LogoutPage from '@/pages/(gapsdk)/logout/page';
import ErrorGiftCardSection from '@/pages/(guest)/_components/ErrorGiftCardSection';
import CheckGiftCardPage from '@/pages/(guest)/check-gift-card/page';
import OrderReceiptPage from '@/pages/(guest)/order-receipt/page';
import CheckAuthPage from '@/pages/check-auth/page';
import Notfound404Page from '@/pages/notfound';
import { compose } from '@/utils/compose';
import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router-dom';
import AuthRoutes from './authenticated';
import Root from './Root';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const Error = () => {
  return <Notfound404Page />;
};

const ErrorGiftCard = () => {
  return <ErrorGiftCardSection />;
};

const router = sentryCreateBrowserRouter([
  {
    path: '/',
    element: compose(<FullLoadingOverlayProvider />, <Root />),
    errorElement: <Error />,
    children: [...AuthRoutes],
  },
  {
    path: '/check-auth',
    element: <CheckAuthPage />,
  },
  {
    path: '/not-found',
    element: <Notfound404Page />,
  },
  {
    path: '/order-receipt',
    element: compose(<FullLoadingOverlayProvider />, <Root />),
    errorElement: <Error />,
    children: [
      {
        path: '/order-receipt',
        element: <OrderReceiptPage />,
      },
    ],
  },
  {
    path: '/:whmcs_id',
    element: compose(<Root />),
    errorElement: <ErrorGiftCard />,
    children: [
      {
        path: '/:whmcs_id',
        element: <CheckGiftCardPage />,
      },
    ],
  },
  {
    path: '/logout',
    element: <LogoutPage />,
  },
]);

export default router;
